import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaListaIndicadoresPlanejamentoEstrategico: ['exercicio'],
    setPlanoEstrategicoConsultaListaIndicadoresPlanejamentoEstrategico: ['planoEstrategico'],
    setTemaConsultaListaIndicadoresPlanejamentoEstrategico: ['tema'],
    setObjetivoEstrategicoConsultaListaIndicadoresPlanejamentoEstrategico: ['objetivoEstrategico'],
    setUnidadeMedidaConsultaListaIndicadoresPlanejamentoEstrategico: ['unidadeMedida'],
    limpaFiltroConsultaListaIndicadoresPlanejamentoEstrategico: [],
    receberFiltroConsultaListaIndicadoresPlanejamentoEstrategico: ['filtroRecebido'],
    setStatusConsultaListaIndicadoresPlanejamentoEstrategico: ['status'],
})

const INITIAL_STATE = {
    exercicio: [],
    planoEstrategico: [],
    tema: [],
    objetivoEstrategico: [],
    unidadeMedida: [],
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setPlanoEstrategico = (state = INITIAL_STATE, action) => {
    return { ...state, planoEstrategico: action.planoEstrategico }
}

const setTema = (state = INITIAL_STATE, action) => {
    return { ...state, tema: action.tema }
}

const setObjetivoEstrategico = (state = INITIAL_STATE, action) => {
    return { ...state, objetivoEstrategico: action.objetivoEstrategico }
}

const setUnidadeMedida = (state = INITIAL_STATE, action) => {
    return { ...state, unidadeMedida: action.unidadeMedida }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: setExercicio,
    [Types.SET_PLANO_ESTRATEGICO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: setPlanoEstrategico,
    [Types.SET_TEMA_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: setTema,
    [Types.SET_OBJETIVO_ESTRATEGICO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: setObjetivoEstrategico,
    [Types.SET_UNIDADE_MEDIDA_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: setUnidadeMedida,
    [Types.LIMPA_FILTRO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: setStatus,
})
